module.exports = __webpack_public_path__ + "ad3a78fc09e9907823b480bbee4190a5.svg";